Ext.define('SA.view.CloseButton', {
    alias: 'widget.close-button',
    extend: 'Ext.Component',


    autoEl: {'aria-label': 'close', tag: 'button'},
    closeAction: 'destroy',
    cls: 'sa-close',
    html: '<svg aria-hidden="true"><use href="#sa-icon-close"></use></svg>',
    overCls: 'sa-close-over',

    initEvents() {
        this.callParent();

        this.el.on('click', () => {
            this.up('[floating], menu')[this.closeAction]();
        });
    }
});
